/** @format */

const template = `
<div class="page-header">
  <div ng-class="{container: ctrl.isInsideContainer}">
    <div class="top-row">
      <sis-breadcrumbs></sis-breadcrumbs>
      <div ng-cloak class="approval-state-panel" ui-view="approvalstatepanel"></div>
      <div ng-cloak class="education-state-panel" ui-view="educationstatepanel"></div>
    </div>
    <sis-page-title></sis-page-title>
    <div ng-cloak class="code-panel" ui-view="codepanel"></div>
    <div ng-cloak class="handler-panel" ui-view="handlerpanel"></div>
  </div>
</div>
`;
export default template;
